export default function baseUrlFrontend() {
    /** Ganti Base URL 
     *
     * Di Akhir Url Jangan pakai 'slash' 
     * Contoh  [x] https://localhost:9090/
     *         [v] https://localhost:9090
    **/
    return process.env.VUE_APP_BASE_URL_FRONT_END+"/#/dashboard"
    // return "http://103.214.113.160:8085/#/dashboard"
    // return "https://dev-back-office.birutekno.com/#/dashboard"
    // return "https://localhost:8080/#/dashboard"
}